<div class="g-layout__container ">
    <div>
        <div class=" flex justify-content-between align-items-center">
            <div class="flex align-items-center">
                <div class="flex cursor-pointer align-items-center ml-2" (click)="goBack()">
                    @if(dir=='rtl'){

                    <i class="pi pi-angle-right g-c-primaryDarkerColor text-xl"></i>
                    }@else {

                    <i class="pi pi-angle-left g-c-primaryDarkerColor text-xl"></i>
                    }
                </div>
                <p class="font-bold  g-c-primaryDarkerColor">
                    {{indicatorId==0?('add indicator'|translate):'edit indicator'|translate}}
                </p>

                @if(indicatorId>0)
                {
                <p class="px-2 g-c-primaryDarkColor font-bold">
                    : {{indicator.name}}
                </p>
                }

            </div>
        </div>
        <div class="br"></div>
        <div>
            <p-stepper [linear]="indicatorId>0?false:true" [(activeStep)]="active">
                <p-stepperPanel header="{{ 'indicator_card' | translate}}">
                    <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
                        <div class="form-container">
                            <form #indicatorForm="ngForm" (ngSubmit)="submitIndicator()">

                                <!-- Strategic Link Section -->
                                <div class="section-header collapsible" (click)="toggleSection('strategicLink')">
                                    <div class="section-title-wrapper">
                                        <i class="fa-solid fa-link"></i>
                                        <h3>{{ 'strategic_link' | translate }}</h3>
                                    </div>
                                    <i class="fa-solid" 
                                       [ngClass]="sectionsExpanded.strategicLink ? 'fa-chevron-up' : 'fa-chevron-down'"
                                       style="color: #1f7895;"></i>
                                </div>
                                
                                <div class="form-grid" *ngIf="sectionsExpanded.strategicLink">
                                    <div class="form-control">
                                        <label class="form-label">{{"pillar"|translate}}</label>
                                        <p-dropdown 
                                            styleClass="modern-dropdown"
                                            (onChange)="onPillarChange(pillar_id)" 
                                            optionLabel="name"
                                            optionValue="id" 
                                            [options]="pillars" 
                                            #pillar_id="ngModel"
                                            name="pillar_id" 
                                            [(ngModel)]="indicator.pillar_id"
                                            placeholder="{{'choose pillar' | translate }}"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(pillar_id.invalid && pillar_id.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{"goal"|translate}}</label>
                                        <p-dropdown 
                                            styleClass="modern-dropdown"
                                            (onChange)="onGoalChange(strategic_goal_id)" 
                                            [filter]="true"
                                            filterBy="name" 
                                            [options]="filterdgoals" 
                                            optionLabel="name"
                                            optionValue="id" 
                                            #strategic_goal_id="ngModel"
                                            name="strategic_goal_id" 
                                            [(ngModel)]="indicator.strategic_goal_id"
                                            placeholder="{{ 'choose_goal' | translate }}"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(strategic_goal_id.invalid && strategic_goal_id.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                </div>
                                
                                <!-- Indicator Data Section -->
                                <div class="section-header collapsible" (click)="toggleSection('indicatorData')">
                                    <div class="section-title-wrapper">
                                        <i class="fa-solid fa-chart-line"></i>
                                        <h3>{{'indicator_data'|translate}}</h3>
                                    </div>
                                    <i class="fa-solid" 
                                       [ngClass]="sectionsExpanded.indicatorData ? 'fa-chevron-up' : 'fa-chevron-down'"
                                       style="color: #1f7895;"></i>
                                </div>
                                
                                <!-- First row: 3 fields -->
                                <div class="form-grid-3" *ngIf="sectionsExpanded.indicatorData">
                                    <div class="form-control">
                                        <label class="form-label">{{"kpi_code"|translate}}</label>
                                        <input pInputText readonly disabled required #code="ngModel" name="code" 
                                            [(ngModel)]="indicator.code" placeholder="{{'kpi_code'|translate}}" />
                                        @if(code.invalid && code.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{"weight"|translate}}</label>
                                        <input pInputText type="number" required #weight="ngModel" name="weight" 
                                            [(ngModel)]="indicator.weight" placeholder="{{'weight'|translate}}" />
                                        @if(weight.invalid && weight.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{ 'balanced_perspective' | translate }}</label>
                                        <p-dropdown 
                                            styleClass="modern-dropdown"
                                            optionLabel="name_ar" 
                                            optionValue="name_en"
                                            [options]="balancedPerspectives" 
                                            required
                                            #balanced_perspective="ngModel" 
                                            name="balanced_perspective"
                                            [(ngModel)]="indicator.balanced_perspective"
                                            placeholder="{{'select_balanced_perspective' | translate }}"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(balanced_perspective.invalid && balanced_perspective.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                </div>
                                
                                <!-- Second row: فئة المؤشر، اسم المؤشر، قطبية المؤشر -->
                                <div class="form-grid-3" *ngIf="sectionsExpanded.indicatorData">
                                    <div class="form-control">
                                        <label class="form-label">{{ 'indicator_category' | translate }}</label>
                                        <p-dropdown 
                                            styleClass="modern-dropdown"
                                            [options]="indicatorCategories" 
                                            optionLabel="name_ar"
                                            optionValue="name_en" 
                                            required 
                                            #category="ngModel" 
                                            name="category"
                                            [(ngModel)]="indicator.category"
                                            placeholder="{{'select_indicator_category' | translate}}"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(category.invalid && category.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{"indicator_name"|translate}}</label>
                                        <input pInputText required type="text" #name="ngModel" name="name"
                                            [(ngModel)]="indicator.name" [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(name.invalid && name.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{"name_in_english"|translate}}</label>
                                        <input pInputText type="text" #name_en="ngModel" name="name_en"
                                            [(ngModel)]="indicator.name_en" [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{"measurement_direction_unit" | translate }}</label>
                                        <p-dropdown 
                                            styleClass="modern-dropdown"
                                            [options]="measurementUnitDirections" 
                                            required
                                            optionLabel="name_ar" 
                                            optionValue="name_en"
                                            #measurement_unit_direction="ngModel"
                                            name="measurement_unit_direction"
                                            [(ngModel)]="indicator.measurement_unit_direction"
                                            placeholder="{{'measurement_direction_unit' | translate }}"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(measurement_unit_direction.invalid && measurement_unit_direction.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                </div>
                                
                                <!-- Third row: Description alone (Full Width) -->
                                <div class="form-grid" *ngIf="sectionsExpanded.indicatorData">
                                    <div class="form-control full-width">
                                        <label class="form-label">{{"indicator_description_measurement_purpose" | translate}}</label>
                                        <textarea pInputTextarea required rows="3" #description="ngModel" name="description"
                                            [(ngModel)]="indicator.description" [disabled]="!indicator.IS_ALLOWED_TO_EDIT"></textarea>
                                        @if(description.invalid && description.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                    <div class="form-control full-width">
                                        <label class="form-label">{{"description_in_english"|translate}}</label>
                                        <textarea pInputTextarea rows="3" #description_en="ngModel" name="description_en"
                                            [(ngModel)]="indicator.description_en" [disabled]="!indicator.IS_ALLOWED_TO_EDIT"></textarea>
                                    </div>
                                </div>
                                
                                <!-- Fourth row: معادلة القياس، وحدة القياس، دورية القياس -->
                                <div class="form-grid-3" *ngIf="sectionsExpanded.indicatorData">
                                    <div class="form-control">
                                        <label class="form-label">{{"measurement_equation" | translate }}</label>
                                        <input pInputText required #measurement_formula="ngModel"
                                            name="measurement_formula" [(ngModel)]="indicator.measurement_formula" 
                                            type="text" [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(measurement_formula.invalid && measurement_formula.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{"unit_of_measurement"|translate}}</label>
                                        <p-dropdown 
                                            styleClass="modern-dropdown"
                                            optionLabel="name_ar" 
                                            optionValue="name_en"
                                            [options]="measurementUnits" 
                                            #measurement_unit="ngModel"
                                            name="measurement_unit" 
                                            [(ngModel)]="indicator.measurement_unit"
                                            placeholder="{{'select_measurement_unit' | translate}}"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(measurement_unit.invalid && measurement_unit.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{"measurement_cycle" | translate }}</label>
                                        <p-dropdown 
                                            styleClass="modern-dropdown"
                                            [options]="measurementCycles" 
                                            optionValue="name_en"
                                            optionLabel="name_ar" 
                                            #measurement_cycle="ngModel"
                                            name="measurement_cycle" 
                                            [(ngModel)]="indicator.measurement_cycle"
                                            placeholder="{{ 'select_measurement_frequency' | translate}}"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(measurement_cycle.invalid && measurement_cycle.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                </div>
                                
                                <!-- Fifth row: المستهدف، مرجعية المستهدف، خط الأساس -->
                                <div class="form-grid-3" *ngIf="sectionsExpanded.indicatorData">
                                    <div class="form-control">
                                        <label class="form-label">{{"target" | translate }}</label>
                                        <input pInputText #target="ngModel" required name="target"
                                            [(ngModel)]="indicator.target" type="text"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(target.invalid && target.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{"target_reference" | translate }}</label>
                                        <input pInputText required #target_reference="ngModel" name="target_reference"
                                            [(ngModel)]="indicator.target_reference" type="text"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(target_reference.invalid && target_reference.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{"baseline" | translate }}</label>
                                        <input pInputText required #base_line="ngModel" name="base_line"
                                            [(ngModel)]="indicator.base_line" type="text"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(base_line.invalid && base_line.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                </div>
                                
                                <!-- Sixth row: فترة عرض النتائج، مصدر بيانات المؤشر، موقع حفظ بيانات المؤشر -->
                                <div class="form-grid-3" *ngIf="sectionsExpanded.indicatorData">
                                    <div class="form-control">
                                        <label class="form-label">{{'result_display_period' | translate}}</label>
                                        <p-dropdown 
                                            styleClass="modern-dropdown"
                                            [options]="measurementCycles" 
                                            optionValue="name_en"
                                            optionLabel="name_ar" 
                                            required 
                                            #results_display_cycle="ngModel"
                                            name="results_display_cycle"
                                            [(ngModel)]="indicator.results_display_cycle"
                                            placeholder="{{ 'select_result_display_period' | translate }}"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(results_display_cycle.invalid && results_display_cycle.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{'indicator_data_source' | translate}}</label>
                                        <input pInputText #data_source="ngModel" required name="data_source"
                                            [(ngModel)]="indicator.data_source" type="text"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(data_source.invalid && data_source.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{'indicator_data_storage_location' | translate}}</label>
                                        <input pInputText required #data_storage_location="ngModel"
                                            name="data_storage_location" [(ngModel)]="indicator.data_storage_location" 
                                            type="text" [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(data_storage_location.invalid && data_storage_location.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                </div>
                                
                                <!-- Date Range -->
                                <form #dateForm="ngForm" appDateRangeValidator
                                    [dateRange]="{ startDate: 'start_date', endDate: 'end_date' }" *ngIf="sectionsExpanded.indicatorData">
                                    <div class="form-grid">
                                        <div class="form-control">
                                            <label class="form-label">{{"start_date"|translate}}</label>
                                            <p-calendar 
                                                styleClass="modern-calendar"
                                                [minDate]="minStartegyDate" 
                                                [maxDate]="maxStrategyDate"
                                                required 
                                                #start_date="ngModel" 
                                                name="start_date"
                                                [(ngModel)]="indicator.start_date" 
                                                [iconDisplay]="'input'"
                                                [showIcon]="true" 
                                                inputId="icondisplay"
                                                [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                            @if(start_date.invalid && start_date.touched){
                                            <span class="field-error">
                                                {{'field_is_required'|translate}}
                                            </span>
                                            }
                                        </div>
                                        
                                        <div class="form-control">
                                            <label class="form-label">{{"end_date"|translate}}</label>
                                            <p-calendar 
                                                styleClass="modern-calendar"
                                                [minDate]="minStartegyDate" 
                                                [maxDate]="maxStrategyDate"
                                                required 
                                                #end_date="ngModel" 
                                                name="end_date"
                                                [(ngModel)]="indicator.end_date" 
                                                [iconDisplay]="'input'"
                                                [showIcon]="true" 
                                                inputId="icondisplay"
                                                [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                            @if(end_date.invalid && end_date.touched){
                                            <span class="field-error">
                                                {{'field_is_required'|translate}}
                                            </span>
                                            }
                                        </div>
                                    </div>
                                    @if(dateForm?.errors?.['dateRangeInvalid'] && indicator.IS_ALLOWED_TO_EDIT){
                                    <div class="field-error">
                                        {{'date_range_validation'|translate}}
                                    </div>
                                    }
                                </form>
                                
                                <!-- Indicator Responsibility Section -->
                                <div class="section-header collapsible" (click)="toggleSection('responsibility')">
                                    <div class="section-title-wrapper">
                                        <i class="fa-solid fa-users"></i>
                                        <h3>{{'indicator_responsibility' | translate }}</h3>
                                    </div>
                                    <i class="fa-solid" 
                                       [ngClass]="sectionsExpanded.responsibility ? 'fa-chevron-up' : 'fa-chevron-down'"
                                       style="color: #1f7895;"></i>
                                </div>
                                
                                <div class="form-grid" *ngIf="sectionsExpanded.responsibility">
                                    <div class="form-control">
                                        <label class="form-label">{{'indicator_responsible_owner' | translate }}</label>
                                        <p-dropdown 
                                            styleClass="modern-dropdown"
                                            [filter]="true" 
                                            filterBy="name" 
                                            [options]="employees"
                                            required 
                                            optionLabel="name" 
                                            optionValue="id" 
                                            #in_charge_id="ngModel"
                                            name="in_charge_id" 
                                            [(ngModel)]="indicator.in_charge_id"
                                            placeholder="{{'select_indicator_responsible_owner' | translate }}"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(in_charge_id.invalid && in_charge_id.touched){
                                        <span class="field-error">
                                            {{"indicator_owner"|translate}}
                                        </span>
                                        }
                                    </div>
                                    
                                    <div class="form-control">
                                        <label class="form-label">{{'indicator_review_officer' | translate }}</label>
                                        <p-dropdown 
                                            styleClass="modern-dropdown"
                                            [filter]="true" 
                                            filterBy="name" 
                                            required 
                                            optionLabel="name"
                                            optionValue="id" 
                                            [options]="employees"
                                            #in_charge_review_id="ngModel" 
                                            name="in_charge_review_id"
                                            [(ngModel)]="indicator.in_charge_review_id"
                                            placeholder="{{'select_indicator_review_officer' | translate }}"
                                            [disabled]="!indicator.IS_ALLOWED_TO_EDIT" />
                                        @if(in_charge_review_id.invalid && in_charge_review_id.touched){
                                        <span class="field-error">
                                            {{'field_is_required'|translate}}
                                        </span>
                                        }
                                    </div>
                                </div>
                                
                                <!-- Form Actions -->
                                <div class="form-actions">
                                    @if(user.strategy_admin){
                                    <p-button 
                                        type="ngSubmit" 
                                        [disabled]="indicatorForm?.invalid || dateForm?.invalid" 
                                        label="{{'next'|translate}}"
                                        [raised]="true" 
                                        styleClass="next-btn" />
                                    }@else{
                                    <p-button 
                                        type="button"
                                        (onClick)="nextCallback.emit()"
                                        [disabled]="indicatorForm?.invalid || dateForm?.invalid" 
                                        label="{{'next'|translate}}"
                                        [raised]="true" 
                                        styleClass="next-btn" />
                                    }
                                </div>
                            </form>
                        </div>
                    </ng-template>
                </p-stepperPanel>



                <p-stepperPanel header="{{ 'enter_indicator_result' | translate}}">
                    <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback"
                        let-index="index">

                        <div class="relative w-full mt-5" style="max-width: 100%;">
                            <div class="flex flex-column gap-3">
                                <div class="flex justify-content-between">

                                    <div>

                                    </div>
                                    <div>
                                        @if(user.strategy_admin){
                                        <a [routerLink]="['/indicators-file-auditor']" [queryParams]="{strategyId: strategyId, indicatorId: indicatorId}">
                                            <p-button label=" {{'output_assessment'|translate}}" />
                                        </a>
                                        }
                                    </div>
                                </div>
                                <div class="outcomes-table-wrapper">

                                    <p-table 
                                        [value]="outcomes" 
                                        [class]="dir" 
                                        [paginator]="true" 
                                        [rows]="5"
                                        [rowsPerPageOptions]="[5, 8, 10]" 
                                        styleClass="modern-outcomes-table"
                                        [tableStyle]="{ 'width': '100%' }">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>
                                                    <i class="fa-solid fa-calendar-days"></i>
                                                    {{'cycle'|translate}}
                                                </th>
                                                <th>
                                                    <i class="fa-solid fa-bullseye"></i>
                                                    {{'target'|translate}}
                                                </th>
                                                <th>
                                                    <i class="fa-solid fa-chart-line"></i>
                                                    {{'actual'|translate}}
                                                </th>
                                                <th>
                                                    <i class="fa-solid fa-spinner"></i>
                                                    {{'progress_status' | translate}}
                                                </th>
                                                <th>
                                                    <i class="fa-solid fa-check-circle"></i>
                                                    {{'approval_status' | translate}}
                                                </th>
                                                <th>
                                                    <i class="fa-solid fa-tools"></i>
                                                    {{'actions'|translate}}
                                                </th>
                                            </tr>
                                        </ng-template>
                                        
                                        <ng-template pTemplate="body" let-outcome>
                                            <tr>
                                                <!-- Cycle Column -->
                                                <td>{{outcome.cycle}}</td>
                                                
                                                <!-- Target Column -->
                                                <td>
                                                    <div class="target-value-box">
                                                        <i class="fa-solid fa-bullseye"></i>
                                                        <span class="value">{{outcome.target}}</span>
                                                    </div>
                                                </td>
                                                
                                                <!-- Actual Column -->
                                                <td>
                                                    <div class="actual-value-box" 
                                                         [ngClass]="getPerformanceClass(outcome.target, outcome.actual)"
                                                         [style.background]="getPerformanceColor(outcome.target, outcome.actual)"
                                                         [style.color]="'white'">
                                                        <i class="fa-solid fa-chart-line"></i>
                                                        <span class="value">{{outcome.actual}}</span>
                                                        <span class="percentage">{{getPerformancePercentage(outcome.target, outcome.actual)}}%</span>
                                                    </div>
                                                </td>
                                                
                                                <!-- Progress Status Column -->
                                                <td>
                                                    @switch (outcome.progress_status)
                                                    {
                                                    @case ('not_started') {
                                                    <p-tag severity="info"
                                                        value="{{outcomeStatusValues['not_started']}}" />
                                                    }
                                                    @case ('in_progress') {
                                                    <p-tag severity="warning"
                                                        value="{{outcomeStatusValues['in_progress']}}" />
                                                    }
                                                    @case ('completed') {
                                                    <p-tag severity="success"
                                                        value="{{outcomeStatusValues['completed']}}" />
                                                    }
                                                    }
                                                </td>
                                                
                                                <!-- Approval Status Column -->
                                                <td>
                                                    @switch (outcome.approval_status)
                                                    {
                                                    @case ('approved') {
                                                    <p-tag severity="success"
                                                        value="{{outcomeStatusValues['approved']}}" />
                                                    }
                                                    @case ('pending') {
                                                    <p-tag severity="warning"
                                                        value="{{outcomeStatusValues['pending']}}" />
                                                    }
                                                    @case ('rejected') {
                                                    <p-tag severity="danger"
                                                        value="{{outcomeStatusValues['rejected']}}" />
                                                    }
                                                    @case ('awaiting_upload') {
                                                    <p-tag severity="info"
                                                        value="{{outcomeStatusValues['awaiting_upload']}}" />
                                                    }
                                                    }
                                                </td>
                                                <td>
                                                    <div class="table-actions-row">
                                                        @if('enter_target' | able:  'Indicator': user){
                                                        <div class="table-action-icon cursor-pointer"
                                                            (click)="openTargetModal(outcome['id'])"
                                                            pTooltip="{{'enter_target'|translate}}"
                                                            tooltipPosition="top">
                                                            <i class="fa-solid fa-bullseye"></i>
                                                        </div>
                                                        }

                                                        @if(outcome['is_allowed_to_upload']){
                                                        <div class="table-action-icon cursor-pointer"
                                                            (click)="openResultModal(outcome['id'])"
                                                            pTooltip="{{'enter_outcome'|translate}}"
                                                            tooltipPosition="top">
                                                            <i class="fa-solid fa-file-arrow-up"></i>
                                                        </div>
                                                        }
                                                        
                                                        @if(outcome['progress_status'] !='not_started'){
                                                        <div class="table-action-icon cursor-pointer"
                                                            (click)="openProofModal(outcome['id'])"
                                                            pTooltip="{{'view_proofs'|translate}}"
                                                            tooltipPosition="top">
                                                            <i class="fa-regular fa-folder-open"></i>
                                                        </div>
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>

                            </div>

                        </div>
                        <div class="flex justify-content-center gap-5 mt-5">
                            <p-button label="{{'back'|translate}}" (onClick)="prevCallback.emit()" />

                            <p-button label="{{'next'|translate}}" (onClick)="nextCallback.emit()" />
                        </div>


                    </ng-template>
                </p-stepperPanel>
                <p-stepperPanel header="{{'view_indicator_results' | translate }}">
                    <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index">

                        <div class="flex justify-content-center gap-3 my-4">
                            <div class="flex align-items-center gap-2">
                                <p-radioButton name="column-marker" value="column-marker" [(ngModel)]="chartType"
                                    inputId="column-marker" />
                                <label for="column-marker" class="ml-2">
                                    {{'column-marker'|translate}}

                                </label>
                            </div>
                            <div class="flex align-items-center gap-2">
                                <p-radioButton name="column-marker" value="column-due" [(ngModel)]="chartType"
                                    inputId="column-due" />
                                <label for="column-due" class="ml-2">
                                    {{'column-due'|translate}}

                                </label>
                            </div>
                        </div>
                        @if(chartType=='column-marker'){
                        <div class="mt-5">
                            <!-- Custom Legend -->
                            <div class="flex justify-content-center align-items-center gap-4 mb-3">
                                <div class="flex align-items-center gap-2">
                                    <div class="w-1rem h-1rem border-round" style="background: #C91F3B;"></div>
                                    <span class="text-sm font-semibold">{{dir === 'rtl' ? 'خط المستهدف' : 'Target Line'}}</span>
                                </div>
                                <div class="flex align-items-center gap-2">
                                    <div class="w-1rem h-1rem border-round" style="background: #10b981;"></div>
                                    <span class="text-sm font-semibold">{{dir === 'rtl' ? 'محقق (≥ المستهدف)' : 'Actual (≥ Target)'}}</span>
                                </div>
                                <div class="flex align-items-center gap-2">
                                    <div class="w-1rem h-1rem border-round" style="background: #546e7a;"></div>
                                    <span class="text-sm font-semibold">{{dir === 'rtl' ? 'محقق (< المستهدف)' : 'Actual (< Target)'}}</span>
                                </div>
                            </div>
                            
                            @if(chartMarkerOptions) {
                            <div id="chart">
                                <apx-chart 
                                    [series]="chartMarkerOptions.series" 
                                    [chart]="chartMarkerOptions.chart"
                                    [xaxis]="chartMarkerOptions.xaxis"
                                    [yaxis]="chartMarkerOptions.yaxis"
                                    [grid]="chartMarkerOptions.grid"
                                    [legend]="chartMarkerOptions.legend" 
                                    [dataLabels]="chartMarkerOptions.dataLabels"
                                    [colors]="chartMarkerOptions.colors"
                                    [fill]="chartMarkerOptions.fill"
                                    [tooltip]="chartMarkerOptions.tooltip"
                                    [plotOptions]="chartMarkerOptions.plotOptions"></apx-chart>
                            </div>
                            }
                            <div class="text-center my-1">
                                {{'measurement_cycle'|translate}} : {{indicator.measurement_cycle_ar}}
                            </div>
                        </div>

                        }@else{

                        <div class="mt-5">
                            @if(chartDueOptions) {
                            <div id="chart">
                                <apx-chart 
                                    [series]="chartDueOptions.series" 
                                    [chart]="chartDueOptions.chart"
                                    [xaxis]="chartDueOptions.xaxis"
                                    [yaxis]="chartDueOptions.yaxis"
                                    [legend]="chartDueOptions.legend" 
                                    [dataLabels]="chartDueOptions.dataLabels"
                                    [colors]="chartDueOptions.colors"
                                    [stroke]="chartDueOptions.stroke"
                                    [tooltip]="chartDueOptions.tooltip"
                                    [plotOptions]="chartDueOptions.plotOptions"></apx-chart>
                            </div>
                            }
                            <div class="text-center my-1">
                                {{'measurement_cycle'|translate}} : {{indicator.measurement_cycle_ar}}
                            </div>
                        </div>
                        }





                        <div class="flex pt-4 justify-content-start">
                            <p-button label="{{'back'|translate}}" class="fixed bottom-0 mb-2"
                                (onClick)="prevCallback.emit()" />
                        </div>
                    </ng-template>
                </p-stepperPanel>
            </p-stepper>


            <!-- target Modal -->
            @if(isTargetModal)
            {
            <div class="modal-wrapper">
                <div class="g-overlay" (click)="closeTargetModal()"></div>
                <div class="g-modal target-modal">
                    <div class="flex  justify-content-between align-items-center flex-row-reverse ">
                        <div (click)="closeTargetModal()"
                            class=" bg-red-500 g-c-white cursor-pointer  w-3rem p-1 shadow-4 text-center  font-bold text-xl  bg-secondary-color border-round">
                            <i class="fa-solid fa-xmark"></i>
                        </div>
                        <div i18n class="titel font-bold text-primary-color g-c-primaryDarkerColor">
                            {{'enter_target'|translate}}
                        </div>

                    </div>
                    <div class="br"></div>
                    <div class="modal__body">
                        <form #TargetForm="ngForm" (ngSubmit)="submitTarget()">
                            <div class="grid">
                                <div class="lg:col-6  col-12 flex flex-column gap-2 mt-5 ">
                                    <label for="cycle">{{'cycle'|translate}}</label>
                                    <div>
                                        <input required #cycle="ngModel" [(ngModel)]="targetDataModal.cycle" id="cycle"
                                            name="cycle" class="w-12" pInputText />
                                        <span class="text-red-500" [hidden]="cycle.valid||cycle.pristine">
                                            {{'field_is_required'|translate}}
                                        </span>
                                    </div>
                                </div>
                                <div class="lg:col-6 col-12  flex flex-column  gap-2 mt-5">
                                    <label for="target">{{'target'|translate}}</label>
                                    <div>
                                        <input required [(ngModel)]="targetDataModal.target" #target="ngModel"
                                            name="target" class="w-12" pInputText id="target" />
                                    </div>
                                    <span class="text-red-500" [hidden]="target.valid||target.pristine">
                                        {{'field_is_required'|translate}}
                                    </span>
                                </div>
                            </div>
                            <div class="mt-5">
                                <button pButton [disabled]="TargetForm.invalid"
                                    type="submit">{{'save'|translate}}</button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
            }
            <!-- result Modal -->


            <div>

                <p-dialog baseZIndex="1000000" header="{{'enter_outcome'|translate}}" [modal]="true"
                    [(visible)]="isActualModal" styleClass="lg:w-6 w-12" (onHide)="closeActualModal()">
                    <form #ReslutForm="ngForm" enctype="multipart/form-data" (ngSubmit)="submitResult()">

                        <div class="flex flex-column gap-3">

                            <div class="flex gap-3">
                                <label class="mb-1 w-2 font-bold g-c-label"
                                    for="cycle">{{'measurement_cycle'|translate}}</label>
                                <span>
                                    :
                                </span>
                                <div class="w-4">
                                    {{actualOutcomeDataModal.cycle}}
                                </div>
                            </div>

                            <div class="flex gap-3">
                                <label class="mb-1 w-2 font-bold g-c-label" for="cycle">{{'target'|translate}}</label>
                                <span>
                                    :
                                </span>
                                <div class="w-4">
                                    {{actualOutcomeDataModal.target}}
                                </div>
                            </div>


                        </div>
                        <!-- updateable -->
                        <div class="grid">
                            <div class=" lg:col-6  col-12 flex flex-column gap-2 mt-5">
                                <label class="mb-1 g-c-label font-semibold" for="name">{{'actual'|translate}}</label>
                                <div>
                                    <input required class="w-12" type="number" step="any" ngModel
                                        [(ngModel)]="actualOutcomeDataModal.actual" #actual="ngModel" name="actual"
                                        pInputText id="actual" />
                                </div>
                                @if((actual.invalid &&
                                !actual.pristine)||(isResulSubmitted&&actual.invalid)){
                                <div>
                                    <span class="text-red-500">
                                        {{'field_is_required'|translate}}
                                    </span>
                                </div>
                                }
                            </div>


                            <div class="lg:col-6  col-12  gap-2 mt-5  flex flex-column gap-2 mt-5">
                                <label class="mb-1 g-c-label font-semibold"
                                    for="source">{{'outcomes_source'|translate}}</label>
                                <div>
                                    <input required class="w-12" ngModel [(ngModel)]="actualOutcomeDataModal.source"
                                        #source="ngModel" name="source" pInputText id="source"
                                        aria-describedby="username-help" />
                                </div>


                                @if((source.invalid &&
                                !source.pristine)||(isResulSubmitted&&source.invalid)){
                                <div>
                                    <span class="text-red-500">
                                        {{'field_is_required'|translate}}
                                    </span>
                                </div>
                                }
                            </div>
                        </div>
                        <div class="grid">

                            <!-- <div class=" lg:col-6  col-12 flex flex-column gap-2 mt-5">
                                <label class="mb-1 g-c-label font-semibold" for="name">{{'causality'|translate}}
                                </label>
                                <div>
                                    <textarea rows="3" class="w-12" ngModel
                                        [(ngModel)]="actualOutcomeDataModal.causality" #causality="ngModel"
                                        name="causality" pInputText id="causality">

                                        </textarea>

                                </div>
                                @if((causality.invalid &&
                                !causality.pristine)||(isResulSubmitted&&causality.invalid)){
                                <div>
                                    <span class="text-red-500"> {{'field_is_required'|translate}}</span>
                                </div>
                                }
                            </div> -->

                            <div class=" lg:col-6  col-12 flex flex-column gap-2 mt-5">
                                <label class="mb-1 g-c-label font-semibold" for="name">
                                    {{'corrective_actions'|translate}}</label>
                                <div>
                                    <textarea rows="3" class="w-12"
                                        [(ngModel)]="actualOutcomeDataModal.corrective_actions"
                                        #corrective_actions="ngModel" name="corrective_actions" pInputText
                                        id="corrective_actions">
                                        </textarea>
                                </div>



                                @if((corrective_actions.invalid &&
                                !corrective_actions.pristine)||(corrective_actions&&corrective_actions.invalid)){
                                <div>
                                    <span class="text-red-500">
                                        {{'field_is_required'|translate}}
                                    </span>
                                </div>
                                }
                            </div>
                        </div>

                        <div class="flex align-items-center justify-content-between">

                            <div class="flex">
                                <div class="g-c-black flex  gap-2 w-fit mx-auto align-items-center">
                                    <div class="flex align-items-center justify-content-center  flex-wrap ">
                                        <div class="flex flex-column align-items-center" (click)="triggerFileInput()">
                                            <p class="g-c-primaryDarkerColor font-bold"> {{'select_evidence'|translate}}
                                            </p>
                                            <div
                                                class="text-2xl  w-6rem text-center cursor-pointer g-c-primaryDarkColor border-round-lg  border-2 py-2">
                                                <i class="fa-solid fa-upload"></i>
                                                <input type="file" hidden #fileInput id="file" multiple ngModel
                                                    #file="ngModel" name="file" (change)="onFileChange($event)"
                                                    required>
                                            </div>
                                            <div>
                                                @if((file.invalid &&
                                                !file.pristine)||(isResulSubmitted&&file.invalid)){
                                                <div>
                                                    <span class="text-red-500">{{'Please_Upload_File'|translate}}</span>
                                                </div>
                                                }

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="w-9">
                                @if(uploadedFilesCount){

                                <p-table [ngClass]="dir" [value]="filesMetaData" ngClass="30rem">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th></th>
                                            <th>{{'file_name'|translate}}
                                            </th>

                                            <th class="text-center"></th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-file let-i="rowIndex">
                                        @if(!file.is_deleted){
                                        <tr>
                                            <td>
                                                <i [class]="file.icon" class=" text-2xl"
                                                    [ngStyle]="{color:file.color}"></i>
                                            </td>
                                            <td style="text-wrap: break-word;">
                                                {{file.name}}
                                            </td>
                                            <td>
                                                <div class="flex  mx-auto align-items-center">
                                                    <div class="text-red-500 text-2xl cursor-pointer"
                                                        (click)="deleteFile(i)">
                                                        <i class="fa-solid fa-rectangle-xmark"></i>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        }
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage" let-c>
                                        <tr>
                                            <td class="text-center font-bold text-lg text-red-500" [attr.colspan]="7">
                                                <i class="fa-solid fa-circle-exclamation"></i>
                                                {{'uploaded_any_files'|translate}}
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                                }@else {
                                <div
                                    class="text-center flex align-items-center mt-5 font-semibold text-lg text-red-500">
                                    <div>
                                        <i class="fa-solid fa-circle-exclamation"></i>
                                        <span>
                                            {{'uploaded_any_files'|translate}}
                                        </span>

                                    </div>
                                </div>
                                }
                            </div>
                        </div>




                        <div class="mx-auto mt-5">

                            <div class="bg-blue-50 text-white p-5  border-1 border-blue-300 border-round-lg  mt-3">
                                <div class="flex align-items-center font-bold text-blue-600 gap-3">

                                    <i class="pi pi-info-circle text-2xl text-blue-600"></i>
                                    <span class="text-center line-height-3">
                                        {{'allowed_to_upload' | translate}}
                                        {{actualOutcomeDataModal.left}}
                                        {{'files_out_of' | translate}}
                                        {{actualOutcomeDataModal.limit}}.
                                        {{'outcome_output_warning' | translate}}
                                    </span>

                                </div>
                            </div>
                        </div>
                        <div class="flex gap-2">
                            <p-checkbox name="isUploadConfirmed" [(ngModel)]="isUploadConfirmed" [binary]="true"
                                inputId="binary" />
                            <p class="white-space-normal font-semibold">
                                {{'confirm_outcome_message'|translate}}
                            </p>

                        </div>

                        <div class="flex align-items-center gap-3 mt-5">
                            <button [disabled]="(ReslutForm.invalid ||!isUploadConfirmed || uploadedFilesCount == 0 )"
                                pButton>{{'save'|translate}}</button>




                            <p-button label="{{'cancel'|translate}}" [outlined]="true" severity="secondary"
                                (onClick)="closeActualModal()" />
                        </div>
                    </form>
                </p-dialog>
            </div>





            <!-- proofs Modal -->

        </div>
    </div>


    @if(isProofModal){
    {{"view_proofs"|translate}}
    <div class="h-screen pt-8  px-4 bg-white shadow-3  lg:w-10 w-full right-0 fixed  top-0  " style="z-index: 900;">
        <div class="pt-2 flex justify-content-between">
            <div></div>
            <div (click)="closeProofModal()"
                class="w-2rem h-2rem bg-red-500 cursor-pointer  shadow-3 hover:bg-red-800   border-circle flex justify-content-center align-items-center">
                <i class="fa-solid fa-xmark text-white  "></i>
            </div>
        </div>
        <div style="overflow-y: auto; max-height: calc(100vh - 10rem);">
            @if(Proofs.length)
            {
            <div style="height: 100%;">
                <p class="text-center font-bold">
                    {{'periodic_measurement_proofs'|translate}} {{selectedOutcome.cycle}}
                </p>
                <p class="text-blue-500 text-center font-bold">
                    <i class="fa-solid fa-circle-info"></i>
                    {{'deleting_proofs'|translate}}
                </p>

                <div class="relative">
                    <div class="table pt-5 ">
                        <p-table [value]="Proofs" [class]="dir" [paginator]="true" [rows]="5"
                            [rowsPerPageOptions]="[5, 8, 10]" [tableStyle]="{ 'min-width': '70rem' }">
                            <ng-template pTemplate="header">
                                <tr>

                                    <th style="text-align: center;">
                                        {{'file_name'|translate}}
                                    </th>
                                    <th style="text-align: center;">
                                        {{"file_type"|translate}}
                                    </th>
                                    <th style="text-align: center;">
                                        {{'target'|translate}}
                                    </th>
                                    <th style="text-align: center;">
                                        {{'actual'|translate}}
                                    </th>
                                    <th style="text-align: center;">
                                        {{'approval_status'|translate}}
                                    </th>
                                    <th style="text-align: center;">
                                        {{'causality'|translate}}
                                    </th>
                                    <th style="text-align: center;">
                                        {{'corrective_actions'|translate}}
                                    </th>
                                    <th></th>
                                </tr>


                            </ng-template>
                            <ng-template pTemplate="body" let-proof>
                                <tr>
                                    <td>
                                        <div class="white-space-nowrap overflow-hidden">
                                            {{proof.file_name}}
                                        </div>
                                    </td>
                                    <td>
                                        {{proof.file_type}}
                                    </td>
                                    <td>
                                        {{proof.target}}
                                    </td>
                                    <td>
                                        {{proof.actual}}
                                    </td>
                                    <td>

                                        @if(dir=='rtl'){
                                        @if(proof.status=='approved'){
                                        <p-tag severity="success" value="معتمد" />
                                        }

                                        @if(proof.status=='rejected'){
                                        <p-tag severity="danger" value="مرفوض" />
                                        }

                                        @if(proof.status=='pending'){
                                        <p-tag severity="warning" value="قيد المراجعة" />
                                        }

                                        }@else{

                                        @if(proof.status=='approved'){
                                        <p-tag severity="success" value="{{proof.status}}" />
                                        }

                                        @if(proof.status=='rejected'){
                                        <p-tag severity="danger" value="{{proof.status}}" />
                                        }

                                        @if(proof.status=='pending'){
                                        <p-tag severity="warning" value="{{proof.status}}" />
                                        }
                                        }
                                    </td>
                                    <td class="w-5rem" style="overflow-wrap: break-word;">
                                        {{proof.causality}}
                                    </td>
                                    <td class="w-5rem" style="overflow-wrap: break-word;">
                                        {{proof.corrective_actions}}
                                    </td>
                                    <td>
                                        <div class="flex align-items-center gap-3">
                                            <div class="cursor-pointer" pTooltip="{{'download'|translate}}"
                                                tooltipPosition="top" showDelay="200"
                                                (click)="downloadProof(proof.id,proof.file_name)">
                                                <i class="pi pi-download"></i>
                                            </div>

                                            @if(proof.status !== 'approved'){
                                            <div class="cursor-pointer" pTooltip="{{'delete'|translate}}"
                                                tooltipPosition="top" showDelay="200"
                                                [ngClass]="{'mr-4':dir=='rtl','ml-4':dir=='ltr'}"
                                                (click)="confirmProofDelete($event,proof.id)">

                                                <i class="pi pi-trash text-red-500">

                                                </i>

                                            </div>
                                            }

                                        </div>
                                        <p-confirmPopup baseZIndex="11000000" #deleteProof>
                                            <ng-template pTemplate="headless" let-message>
                                                <div class="border-round p-3">
                                                    <span>
                                                        {{ message.message }}</span>
                                                    <div class="flex align-items-center gap-2 mt-3">
                                                        <p-button i18n-label (click)="accept()"
                                                            label="{{'yes'|translate}}" severity="danger"></p-button>
                                                        <p-button i18n-label (click)="reject()"
                                                            label="{{'no'|translate}}" severity="secondary"></p-button>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </p-confirmPopup>

                                    </td>

                                </tr>
                            </ng-template>
                        </p-table>

                    </div>

                </div>





            </div>
            }@else{
            <div class="w-full h-full">
                <p class="font-bold text-red-500 text-center text-lg">
                    {{'no_proofs'|translate}}
                </p>
            </div>
            }
        </div>
    </div>
    }